import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCyberDefensecosts = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 64,
	height: 64,
	fill: "currentColor",
	viewBox: "0 0 64 64",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "M32 62.35c-.16 0-.33-.04-.47-.12-11.38-6.1-19.4-18.37-23.19-35.48C5.49 13.92 6.01 2.72 6.01 2.61c.03-.53.47-.95 1-.95h49.98c.53 0 .97.42 1 .95 0 .11.52 11.31-2.33 24.15-3.79 17.11-11.81 29.37-23.19 35.48-.15.08-.31.12-.47.12zM7.98 3.65c-.1 6.41.37 43.38 24.02 56.55C55.65 47.04 56.12 10.07 56.02 3.65z" }),
		/* @__PURE__ */ _jsx("path", { d: "M32 39.51c-3.78 0-6.86-3.08-6.86-6.86 0-.55.45-1 1-1s1 .45 1 1c0 2.68 2.18 4.86 4.86 4.86 2.82 0 4.86-1.84 4.86-4.37 0-2.15-1.71-3.63-5.08-4.4-5.49-1.25-6.64-4.14-6.64-6.35 0-3.63 2.95-6.37 6.86-6.37 3.36 0 6.2 2.4 6.77 5.72a.997.997 0 0 1-.82 1.15.984.984 0 0 1-1.15-.82 4.844 4.844 0 0 0-4.79-4.05c-2.82 0-4.86 1.84-4.86 4.37 0 2.15 1.71 3.63 5.08 4.4 5.49 1.25 6.64 4.14 6.64 6.35 0 3.63-2.95 6.37-6.86 6.37z" }),
		/* @__PURE__ */ _jsx("path", { d: "M32 42.44c-.55 0-1-.45-1-1v-2.93c0-.55.45-1 1-1s1 .45 1 1v2.93c0 .55-.45 1-1 1m0-24.42c-.55 0-1-.45-1-1v-2.93c0-.55.45-1 1-1s1 .45 1 1v2.93c0 .55-.45 1-1 1" })
	]
});
export default SvgCyberDefensecosts;
